/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{isPrimaryPointer as r}from"./utils/is-primary-pointer.js";function t(r,t="page"){return{point:{x:r[t+"X"],y:r[t+"Y"]}}}const i=i=>o=>r(o)&&i(o,t(o));export{i as addPointerInfo,t as extractEventInfo};
//# sourceMappingURL=event-info.js.map
